<!-- Rendered as a tab of "Verhalten & Fähigkeiten" — client scope under
     /agent-setup/learnings, agent scope under /tutors/:id/setup/learnings.
     The host page owns the page header, the card and (agent scope) the
     tutor menu; this component renders content only. -->
<ng-container *ngIf="scope === 'bot'; else body">
  <!-- The two switches of the feature live here, not in the AI
       configuration: one home per switch. -->
  <section class="tile-flat settings" *ngIf="enabledSetting">
    <header class="tile-flat__header">
      <h5>{{ "pages.learnings.settingsTitle" | translate }}</h5>
    </header>
    <app-tutor-settings
      [tutorSetting]="enabledSetting"
      [tutor]="tutor"
      (settingValueSaved)="onSettingSaved()"
    ></app-tutor-settings>
    <app-tutor-settings
      *ngIf="topKSetting && featureEnabled"
      [tutorSetting]="topKSetting"
      [tutor]="tutor"
      (settingValueSaved)="onSettingSaved()"
    ></app-tutor-settings>
    <p *ngIf="!featureEnabled" class="hint hint--warning">
      {{ "pages.learnings.disabledHint" | translate }}
    </p>
  </section>

  <ng-container *ngTemplateOutlet="body"></ng-container>

  <!-- Runs exactly the search the agent runs: same SQL, same model,
       both scopes, the agent's own top_k. -->
  <section class="tile-flat test">
    <header class="tile-flat__header">
      <h5>{{ "pages.learnings.test.title" | translate }}</h5>
    </header>
    <p class="scope-note">{{ "pages.learnings.test.hint" | translate }}</p>
    <div class="test-row">
      <nb-select
        *ngIf="courses.length"
        size="small"
        class="test-course"
        [nbTooltip]="'pages.learnings.tooltips.testCourse' | translate"
        [(selected)]="testCourseId"
        [placeholder]="'pages.learnings.test.noCourse' | translate"
      >
        <nb-option [value]="null">{{ "pages.learnings.test.noCourse" | translate }}</nb-option>
        <nb-option *ngFor="let c of courses" [value]="c.id">{{ c.name }}</nb-option>
      </nb-select>
      <input
        nbInput
        fullWidth
        fieldSize="small"
        data-enter-ignore
        [nbTooltip]="'pages.learnings.tooltips.testQuery' | translate"
        [(ngModel)]="testQuery"
        (keydown.enter)="runTest()"
        [placeholder]="'pages.learnings.test.placeholder' | translate"
      />
      <button
        nbButton
        status="primary"
        size="small"
        type="button"
        [disabled]="testRunning || !testQuery.trim()"
        [nbSpinner]="testRunning"
        [nbTooltip]="'pages.learnings.tooltips.testRun' | translate"
        (click)="runTest()"
      >
        {{ "pages.learnings.test.run" | translate }}
      </button>
    </div>
    <ng-container *ngIf="testHits">
      <p class="scope-note">
        {{ "pages.learnings.test.result" | translate: { count: testHits.length, limit: testLimit } }}
      </p>
      <ol class="test-hits" *ngIf="testHits.length">
        <li *ngFor="let hit of testHits; trackBy: trackHit">
          <div class="test-hit__meta">
            <span class="badge" [class.badge--client]="hit.scope === 'client'">
              {{
                (hit.scope === "client"
                  ? "pages.learnings.scope.clientWide"
                  : "pages.learnings.scope.thisAgent"
                ) | translate
              }}
            </span>
            <span>{{ "pages.learnings.types." + (hit.value.always ? "ruleAlways" : hit.value.type) | translate }}</span>
            <span *ngIf="hit.score !== null" class="score">
              {{ hit.score | number: "1.2-2" }}
            </span>
          </div>
          <div class="test-hit__title" *ngIf="hit.value.topic || hit.value.question">
            {{ hit.value.question || hit.value.topic }}
          </div>
          <div class="test-hit__content">{{ hit.value.content }}</div>
          <div class="test-hit__anchor" *ngIf="hit.matched_anchor">
            {{ "pages.learnings.test.matchedAnchor" | translate: { anchor: hit.matched_anchor } }}
          </div>
        </li>
      </ol>
    </ng-container>
  </section>
</ng-container>

<ng-template #body>
  <div class="scope-bar">
    <span class="scope-note">
      {{
        (scope === "bot"
          ? "pages.learnings.scopeNoteBot"
          : canWriteClient
            ? "pages.learnings.scopeNote"
            : "pages.learnings.scopeNoteReadOnly"
        ) | translate
      }}
      <a *ngIf="scope === 'bot'" routerLink="/agent-setup/learnings">
        {{ "pages.learnings.manageClient" | translate }}
      </a>
    </span>
    <span *ngIf="truncated" class="truncation-note">
      {{ "pages.learnings.truncated" | translate: { shown: learnings.length, total: total } }}
    </span>
  </div>

  <!-- Rows without an embedding are invisible to the agent. Say so, and
       offer the fix, instead of letting people wonder why a learning is
       never used. -->
  <div class="reembed-bar" *ngIf="unsearchableCount > 0 && canWrite">
    <span class="hint hint--warning">
      {{ "pages.learnings.unsearchable" | translate: { count: unsearchableCount } }}
    </span>
    <button
      nbButton
      size="small"
      status="basic"
      type="button"
      [disabled]="reembedding"
      [nbSpinner]="reembedding"
      [nbTooltip]="'pages.learnings.tooltips.reembed' | translate"
      (click)="reembed()"
    >
      {{ "pages.learnings.reembed" | translate }}
    </button>
  </div>

  <div class="search-bar" *ngIf="learnings.length > 0">
    <app-search-input
      [(value)]="searchText"
      (valueChange)="onSearchChange()"
      placeholderKey="pages.learnings.searchPlaceholder"
    ></app-search-input>
  </div>

  <app-table
    rowIdKey="id"
    [nbSpinner]="isLoading"
    [title]="''"
    [columns]="columns"
    [data]="filteredLearnings"
    [rowActions]="rowActions"
    [globalActions]="globalActions"
    [maxVisibleItems]="pageSize"
    [options]="{ resetPageOnDataChange: false }"
    (event)="onTableEvent($event)"
  ></app-table>
</ng-template>
